import { Map } from 'immutable';

export default function getErrorFromState(slice) {
  return state => state.getIn([slice, 'error'], Map());
}
